import { productCatalogue, type ProductCatalogueEntry } from '../catalogue/products';
import type { EntitlementMap, ProductEntitlement } from '../types/entitlements';

export type ProductSections = {
  active: Array<[ProductCatalogueEntry, ProductEntitlement]>;
  available: Array<[ProductCatalogueEntry, ProductEntitlement | undefined]>;
};

// Partition the product catalogue into the two on-screen groups: "Your products"
// (active subscriptions) and "Available across Cloudhouse" (cross-sell). Pure: no
// React, no SDK, no I/O. Org-admin-only products (e.g. Org Control Panel) appear as
// active for admins and are omitted entirely for everyone else; products marked
// hidden by an entitlement are dropped.
export function resolveProductSections(
  entitlements: EntitlementMap,
  isOrgAdmin: boolean,
): ProductSections {
  const active: ProductSections['active'] = [];
  const available: ProductSections['available'] = [];
  for (const product of productCatalogue) {
    if (product.notYetOffered) continue;
    if (product.requiresOrgAdmin && !isOrgAdmin) continue;
    if (product.requiresOrgAdmin && isOrgAdmin) {
      active.push([product, { status: 'active' }]);
      continue;
    }
    const e = entitlements[product.key];
    if (e?.status === 'hidden') continue;
    if (e?.status === 'active') active.push([product, e]);
    else available.push([product, e]);
  }
  return { active, available };
}
